import apiService from './api-client';

interface NotificationType {
    id: string;
    message: string;
    is_read: boolean;
    created_at: string;
}

/**
 * Obtiene todas las notificaciones para el usuario actual.
 */
const getNotifications = async (): Promise<NotificationType[]> => {
  const response = await apiService().get<NotificationType[]>('/notifications/');
  return response.data;
};

/**
 * Marca una notificación específica como leída.
 * @param notificationId - El ID de la notificación.
 */
const markAsRead = async (notificationId: string | number): Promise<void> => {
  await apiService().post(`/notifications/${notificationId}/read`, {});
};

export const notificationsService = {
  getNotifications,
  markAsRead,
};